import z, { ZodType } from 'zod';
import { Player, playerSchema } from './player';

export type DeviceActivatedResponse = {
	id: number;
	name: string;
	isActive: boolean;
	players: Player[];
};

export const deviceActivatedResponseSchema: ZodType<DeviceActivatedResponse> = z.object({
	id: z.number(),
	name: z.string(),
	isActive: z.boolean(),
	players: z.array(playerSchema),
});
